import _ from 'lodash';
import $ from 'jquery';
import angular from 'angular';
import template from './staticCriteriaView.html';
import searchItemsPriority, {
    additionalCriterionTextValues,
    additionalCriterionValues,
    preferredPrioritySupportCriterias,
    staticCriteriaFields,
} from '../../constants/searchItemsPriority';

export class StaticCriteriaComponent {
    /* @ngInject */
    constructor(staticDataService, searchCacheService, $element, $timeout, $scope) {
        const staticCriteriaCtrl = this;
        this.$scope = $scope;
        this.$scope.searchItemsPriority = searchItemsPriority;
        this.$scope.preferredPrioritySupportCriterias = preferredPrioritySupportCriterias;

        staticCriteriaCtrl.init = function () {
            staticCriteriaCtrl.mandatoryValues = [
                {
                    value: 'optional',
                    text: 'NORMAL',
                },
                {
                    value: 'preferred',
                    text: 'PREFERRED_PRIORITY_LABEL',
                },
                {
                    value: 'mandatory',
                    text: 'MANDATORY_MINUS',
                },
                {
                    value: 'filter',
                    text: 'MANDATORY',
                },
            ];
        };

        staticCriteriaCtrl.initData = function () {
            staticCriteriaCtrl.showAdd = false;
            staticCriteriaCtrl.showDropDown = false;
            staticCriteriaCtrl.showSubCriteria = false;
            staticCriteriaCtrl.requiredIndexes = [];
            for (let i = 0; i < staticCriteriaCtrl.data.selected.length; i++) {
                if (staticCriteriaCtrl.data.selected[i].required === true) {
                    staticCriteriaCtrl.data.selected[i].required = 'mandatory';
                } else if (!staticCriteriaCtrl.data.selected[i].required) {
                    staticCriteriaCtrl.data.selected[i].required = 'optional';
                } else if (staticCriteriaCtrl.data.selected[i].required === 0 || staticCriteriaCtrl.data.selected[i].required === false) {
                    staticCriteriaCtrl.data.selected[i].required = 'optional';
                }
                const index = _.findIndex(staticCriteriaCtrl.mandatoryValues, { value: staticCriteriaCtrl.data.selected[i].required });
                if (index >= 0) {
                    staticCriteriaCtrl.requiredIndexes.push({
                        requiredValue: index,
                    });
                } else {
                    staticCriteriaCtrl.requiredIndexes.push({
                        requiredValue: 0,
                    });
                }
            }
            staticCriteriaCtrl.getStaticData();

            if (staticCriteriaCtrl.data.multiple
                && staticCriteriaCtrl.lastSearch
                && staticCriteriaCtrl.lastSearch.field === staticCriteriaCtrl.data.field
            ) {
                staticCriteriaCtrl.showAdd = true;
                staticCriteriaCtrl.filterValues = staticCriteriaCtrl.lastSearch.value;
            }
            this.getSubCriteriaData();
            this.hasPreferred = preferredPrioritySupportCriterias.includes(staticCriteriaCtrl.data.field);
        };

        staticCriteriaCtrl.goToBottom = function () {
            if ($element[0].getBoundingClientRect().bottom > document.documentElement.clientHeight) {
                const scrollTop = $(window)
                    .scrollTop();
                $timeout(() => {
                    $(window)
                        .scrollTop(($element[0].getBoundingClientRect().bottom - document.documentElement.clientHeight)
                            + scrollTop + 20);
                }, 400);
            }
        };

        staticCriteriaCtrl.getStaticData = function () {
            staticDataService.getStaticData(staticCriteriaCtrl.data.lookupData, (data) => {
                staticCriteriaCtrl.staticData = angular.copy(data);
                staticCriteriaCtrl.filteredStaticData = staticCriteriaCtrl.staticData;

                if (staticCriteriaCtrl.staticData) {
                    staticCriteriaCtrl.data.selected = (staticCriteriaCtrl.data.selected || []).map((item) => {
                        const foundedValue = staticCriteriaCtrl.staticData.find(({ id }) => id === item.uid);

                        if (foundedValue && !item.value) {
                            return {
                                ...item,
                                ...foundedValue,
                            };
                        }

                        return item;
                    });
                }
            });
            if (staticCriteriaCtrl.data.subCriteria !== null) {
                staticDataService.getStaticData(staticCriteriaCtrl.data.subCriteria.lookupData, (data) => {
                    staticCriteriaCtrl.staticSubCriteriaData = data;

                    if (staticCriteriaCtrl.staticSubCriteriaData) {
                        staticCriteriaCtrl.data.selected = (staticCriteriaCtrl.data.selected || []).map((item) => {
                            const additionalId = _.get(item, 'additional.uid');
                            const currentAdditionalValue = _.get(item, 'additional.value');
                            const additionalData = staticCriteriaCtrl.staticSubCriteriaData.find(({ id }) => id === additionalId);

                            if (additionalData && !currentAdditionalValue) {
                                return {
                                    ...item,
                                    additional: {
                                        ...item.additional,
                                        ...additionalData,
                                    },
                                };
                            }

                            return item;
                        });
                    }
                });
            }
        };

        staticCriteriaCtrl.subCriteriaChosen = function (value, init) {
            staticCriteriaCtrl.subCriteriaValue = value;
            staticCriteriaCtrl.showSubCriteria = false;
            if (init && staticCriteriaCtrl.dynamicSubCriteriaData) {
                const defaultSubCriteria = _.find(staticCriteriaCtrl.dynamicSubCriteriaData, { isDefault: true });
                if (defaultSubCriteria) {
                    staticCriteriaCtrl.subCriteriaValue = defaultSubCriteria;
                } else {
                    staticCriteriaCtrl.subCriteriaValue = value;
                }
                staticCriteriaCtrl.showSubCriteria = false;
                return;
            }
            staticCriteriaCtrl.subCriteriaValue = value;
            staticCriteriaCtrl.showSubCriteria = false;
            if (staticCriteriaCtrl.inputReadyOnly && !init) {
                if (staticCriteriaCtrl.data.selected.length > 0) {
                    staticCriteriaCtrl.filterValueChosen(staticCriteriaCtrl.data.selected[0]);
                } else {
                    staticCriteriaCtrl.filterValueChosen(staticCriteriaCtrl.originalValue);
                }
            }
        };

        staticCriteriaCtrl.staticInputChange = function () {
            const staticData = staticCriteriaCtrl?.staticData;
            if (!staticData) {
                staticCriteriaCtrl.filteredStaticData = staticData;
            }
            if (!staticCriteriaCtrl.filterValues && staticCriteriaCtrl.data.selected.length === 0) {
                staticCriteriaCtrl.filteredStaticData = staticData;
            }
            const newData = [];
            if (staticData && staticData.length) {
                for (let i = 0; i < staticData.length; i++) {
                    if (staticCriteriaCtrl.filterValues) {
                        const filterValue = (staticCriteriaCtrl.filterValues || '');
                        const staticText = (staticData[i].text || '');
                        if (staticText.toLowerCase()
                            .indexOf(filterValue.toLowerCase()) >= 0) {
                            newData.push(staticData[i]);
                        }
                    } else if (!(_.find(staticCriteriaCtrl.data.selected, { uid: staticData[i].id }))) {
                        newData.push(staticData[i]);
                    }
                }
            }
            staticCriteriaCtrl.filteredStaticData = newData;
        };

        staticCriteriaCtrl.staticChosen = function (value) {
            if (!value) {
                return;
            }
            if (staticCriteriaCtrl.data.multiple === false && staticCriteriaCtrl.data.selected.length == 1) {
                staticCriteriaCtrl.data.selected[0].uid = value.id.toString();
                staticCriteriaCtrl.data.selected[0].value = value.text;
                staticCriteriaCtrl.data.selected[0].text = null;
                staticCriteriaCtrl.showDropDown = false;
                staticCriteriaCtrl.showAdd = false;
                staticCriteriaCtrl.filterValues = '';
            } else {
                const selected = {
                    uid: value.id.toString(),
                    value: value.text,
                    required: 'optional',
                };
                const subCriteriaValue = staticCriteriaCtrl?.subCriteriaValue;

                if (staticCriteriaCtrl.data.subCriteria !== null
                    && (
                        staticCriteriaCtrl.subCriteriaValue
                        || (
                            _.isUndefined(subCriteriaValue)
                            && staticCriteriaCtrl.data.field === staticCriteriaFields.languages
                        )
                    )) {
                    selected.additional = {
                        uid: subCriteriaValue ? subCriteriaValue.id.toString() : additionalCriterionValues.BASIC,
                        value: subCriteriaValue ? subCriteriaValue.text : additionalCriterionTextValues.BASIC,
                    };
                }
                if (!_.find(staticCriteriaCtrl.data.selected, { value: selected.value })) {
                    staticCriteriaCtrl.data.selected.push(selected);
                }
                if (staticCriteriaCtrl.data.multiple == true) {
                    staticCriteriaCtrl.staticInputChange();
                } else {
                    staticCriteriaCtrl.showDropDown = false;
                    staticCriteriaCtrl.showAdd = false;
                    staticCriteriaCtrl.filterValues = '';
                }
            }
            searchCacheService.saveLastSearchField(staticCriteriaCtrl.data.field, staticCriteriaCtrl.filterValues);
        };

        staticCriteriaCtrl.closeStatic = function () {
            staticCriteriaCtrl.showAdd = false;
            staticCriteriaCtrl.showDropDown = false;
        };

        staticCriteriaCtrl.removeValue = function (index) {
            staticCriteriaCtrl.data.selected.splice(index, 1);
            staticCriteriaCtrl.requiredIndexes.splice(index, 1);
        };

        staticCriteriaCtrl.modifyValue = function () {
            staticCriteriaCtrl.showAdd = true;
        };

        staticCriteriaCtrl.setRequiredSubCriteria = function (idx, value) {
            staticCriteriaCtrl.mandatoryPopUpView = -1;
            staticCriteriaCtrl.data.selected[idx].required = value.required;
            const index = _.findIndex(staticCriteriaCtrl.mandatoryValues, { value: staticCriteriaCtrl.data.selected[idx].required });
            if (staticCriteriaCtrl.requiredIndexes.length <= 0) {
                if (index >= 0) {
                    staticCriteriaCtrl.requiredIndexes.push({
                        requiredValue: index,
                    });
                } else {
                    staticCriteriaCtrl.requiredIndexes.push({
                        requiredValue: 0,
                    });
                }
            } else if (index >= 0) {
                if (staticCriteriaCtrl.requiredIndexes[idx]) {
                    staticCriteriaCtrl.requiredIndexes[idx].requiredValue = index;
                } else {
                    staticCriteriaCtrl.requiredIndexes.push({
                        requiredValue: index,
                    });
                }
            } else if (staticCriteriaCtrl.requiredIndexes[idx]) {
                staticCriteriaCtrl.requiredIndexes[idx].requiredValue = 0;
            } else {
                staticCriteriaCtrl.requiredIndexes.push({
                    requiredValue: index,
                });
            }
            const subCriterita = _.find(staticCriteriaCtrl.dynamicSubCriteriaData, { text: value.additional });
            if (subCriterita) {
                staticCriteriaCtrl.subCriteriaValue = subCriterita;
                staticCriteriaCtrl.data.selected[idx].additional = {
                    uid: staticCriteriaCtrl.subCriteriaValue.id,
                    value: staticCriteriaCtrl.subCriteriaValue.text,
                };
            }
        };

        staticCriteriaCtrl.getSubCriteriaData = function () {
            if (staticCriteriaCtrl.data.subCriteria !== null) {
                staticDataService.getStaticData(staticCriteriaCtrl.data.subCriteria.lookupData, (data) => {
                    staticCriteriaCtrl.dynamicSubCriteriaData = data;

                    if (data) {
                        staticCriteriaCtrl.data.selected = (staticCriteriaCtrl.data.selected || []).map((item) => {
                            const additionalId = _.get(item, 'additional.uid');
                            const currentAdditionalValue = _.get(item, 'additional.value');
                            const additionalValue = data.find(({ id }) => id === additionalId);

                            if (additionalValue && !currentAdditionalValue) {
                                return {
                                    ...item,
                                    additional: {
                                        ...item.additional,
                                        ...additionalValue,
                                    },
                                };
                            }

                            return item;
                        });
                    }
                });
            }
        };

        staticCriteriaCtrl.setPopupView = function (value) {
            staticCriteriaCtrl.mandatoryPopUpView = value;
        };

        staticCriteriaCtrl.init();
    }
}

export const StaticCriteriaComponentConfiguration = {
    template,
    bindings: {
        data: '=',
        lastSearch: '=',
        allData: '=',
        disable: '=',
    },
    controller: StaticCriteriaComponent,
    controllerAs: 'staticCriteriaCtrl',
};

angular
    .module('TALENYA-FE')
    .component('staticCriteriaComponent', StaticCriteriaComponentConfiguration);
